import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sendCode } from "../api/code";

export const getCodeData = createAsyncThunk(
  "code/getCodeData",
  async ({ firebaseIntegrationFile }, { rejectWithValue }) => {
    const phone = sessionStorage.getItem("phone");
    const firebaseJsonUrl = `${process.env.REACT_APP_ACCOUNTS_BASE_URL}/${firebaseIntegrationFile}`;
    console.log("firebaseJsonUrl", firebaseJsonUrl);
    // console.log("Fetching Firebase JSON from URL:", firebaseJsonUrl);

    try {
      //   // Fetch the JSON content from the URL
      //   // const response = await fetch(firebaseJsonUrl);

      //   // Log response status for debugging
      //   // console.log("Response status:", response.status);

      //   if (!response.ok) {
      //     throw new Error(
      //       `Failed to fetch Firebase JSON file: ${response.statusText}`
      //     );
      //   }

      // Parse the JSON content
      // const jsonContent = await response.json();

      // Log the JSON content for debugging
      // console.log("Fetched JSON content:", jsonContent);

      // Convert the JSON content into a Blob object
      // const firebaseJsonFile = new Blob([JSON.stringify(jsonContent)], {
      //   type: "application/json",
      // });

      // Log the Blob for debugging
      // console.log("Converted JSON Blob:", firebaseJsonFile);

      // Call the sendCode API with the phone number and Blob
      const { data } = await sendCode({ phone, firebaseJsonUrl });

      // Log the API response for debugging
      console.log("API response:", data);

      return data;
    } catch (error) {
      console.error("Error in getCodeData:", error.message || error);

      // Return the error for proper handling in the rejected case
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

const initialValues = {
  code: null,
  isLoading: false,
  isError: null,
};

const sendCodeSlice = createSlice({
  name: "code",
  initialState: initialValues,
  extraReducers: (builder) => {
    builder
      .addCase(getCodeData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.code = action.payload;
      })
      .addCase(getCodeData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCodeData.rejected, (state, action) => {
        state.isError = action.payload || "An error occurred";
        state.isLoading = false;
      });
  },
  reducers: {},
});

export const sendCodeReducer = sendCodeSlice.reducer;
